import React from "react";
import Box from "../common/Box";
import Stack from "../common/Stack";
import Text from "../common/Text";
import Button from "../common/Button";

const DocumentsList = ({ list, ...props }) => {
  if (!list || !Array.isArray(list)) {
    return null;
  }

  return (
    <Stack spacing={3}>
      {list
        .filter(({ document_item }) => document_item && document_item.publicURL)
        .map(({ document_item, document_title }, i) => (
          <Box key={i}>
            <Button
              as="a"
              href={document_item.publicURL}
              target="_blank"
              key={i}
              icon="file"
            >
              {document_title || "Fichier"}
              <br />
              <Text as="span" fontWeight="normal">
                {document_item.extension}
              </Text>
            </Button>
          </Box>
        ))}
    </Stack>
  );
};

export default DocumentsList;
